import common from "../common";
import Button from "./Button";
import MiniSignal from 'mini-signals';

export default class TextInput extends Button
{
    constructor(label, id, attributes = {}, css = {}, fieldCss = {})
    {
        if(css.height == undefined)
            css.height = '7' + common.cssUnit;
        if(css.width == undefined)
            css.width = '30%';

        super(css);

        this.css = css;
        this.fieldCss = fieldCss;

        this.attributes = attributes;

        this.signals.blur = new MiniSignal();

        this.backing = null;
        this.border = null;
        this.validationMessage = null;

        this.currentValue = '';

        this.initTextField(label, id, attributes);

        this.label = label;
    }

    initTextField(label, id, attributes)
    {
    	this.type = Button.TYPE_TEXT_INPUT;
    
        this.formElement = $("<input type='text' class='p3-textField' id='" +  id + "' name='" + label + "' />");

        this.formElement.css(this.fieldCss);

        if(this.attributes.value)
            this.formElement.attr('value', this.attributes.value);

        this.currentValue = attributes.value;

        console.log('text input checking size');
        console.log(attributes);
        if(this.attributes.size)
        {
            console.log('setting size');
            this.formElement.attr('maxlength', this.attributes.size);
        }

        this.htmlElement.append(this.formElement);

        var that = this;
        this.formElement.on('input keydown keyup mousedown mouseup select contextmenu drop', function(){
            var bannedChars = ['<', '>', '=', '”', '&', '#', '(', ')', " "];
            var value = $(this).val();
            for(var i in bannedChars)
            {
                var spl = value.split(bannedChars[i]);
                value = spl.join('');
            }
            $(this).val(value);
            that.onFieldChange(value);
        });
        this.formElement.on('blur', (e) => {
            that.signals.blur.dispatch(e);
        });
        this.formElement.focusin((e) => {
            that.signals.inputFocusIn.dispatch(e);
        });
        this.formElement.focusout((e) => {
            that.signals.inputFocusOut.dispatch(e);
        });
    }

    onFieldChange(value)
    {
        //this.validateField(value);
        this.currentValue = value;
        this.signals.changed.dispatch(value);
    }

    validateField(value)
    {
        var bannedChars = ['<', '>', '=', '”', '&', '#', '(', ')', " "];
        for(var i in bannedChars)
        {
            var spl = value.split(bannedChars[i]);
            value = spl.join('');
        }

        if(this.attributes.type == 'integer')
        {
            value = /^\d*$/.test(value) ? value : this.currentValue;
        }
        else if(this.attributes.type == 'float')
        {
            value = /^-?\d*[.,]?\d*$/.test(value) ? value : this.currentValue;
        }
        
        if(this.attributes.type == 'integer' || this.attributes.type == 'float')
        {
            if(isNaN(Number(value)) || Number(value) < this.attributes.min || Number(value) > this.attributes.max)
            {
                value = this.currentValue;
            }
        }
        if(this.attributes.size)
        {
            var v = String(value);
            if(v.indexOf('.') > -1)
            {
                v = v.replace('.', '');
            }
            if(v.length > this.attributes.size)
            {
                value = this.currentValue;
            }
        }

        if(common.isAndroid && !common.isKindle)
        {
            setTimeout(function()
            {  
                this.formElement.val(value);
            }.bind(this), 2);
        }
        else
        {
            this.formElement.val(value);
        }
        
        this.currentValue = value;

        if(value != "" && this.validationMessage)
        {
            this.validationMessage.hide();
        }
    }

    setTextAlignLeft()
    {
        this.formElement.css('textAlign', 'left');
    }

    setPlaceholder(text)
    {
        this.formElement.attr('placeholder', text);
    }

    onFocusIn(e)
    {
        super.onFocusIn();
        console.log('onFocusIn');
    }

    onFocusOut(e)
    {
        super.onFocusOut();
        console.log('onFocusOut');
    }

    get value()
    {
        return this.formElement.val();
    }

    set value(value)
    {
        this.formElement.val(value);
        this.validateField(value);
    }
}